<template>
  <div>
    <center>
      <h1>Watchlist Settings Edit</h1>
      <p>Edit Watchlist Settings</p>
    </center>
    <hr>
    <v-btn @click="goBack()" class="ma-2" color="primary" text><v-icon darkleft>mdi-arrow-left</v-icon>Back</v-btn>
    <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
    <v-layout class="watchlistSettings" column align-center>
      <h2 id="departmentHeader"> {{watchlistSettings.item}} </h2>
      <div class="switches">
        <v-switch v-if="textAlertingAllowed" :disabled="!premiumUsr" v-model="text" label="Text Alerts"></v-switch>
        <v-switch :disabled="!premiumUsr" v-model="email" label="Email Alerts"></v-switch>
        <v-switch :disabled="!premiumUsr" v-model="push" label="Browser Notifications (Not Supported on iPhone)"></v-switch>
        <v-switch v-model="watchlist" label="Incidents Appear on Watchlist"></v-switch>
      </div>
      <div class="button-container">
        <v-btn @click="saveButton()" id="saveButton" depressed color="primary">SAVE</v-btn>
        <v-btn @click="deleteButton()" id="deleteButton" depressed color="error">DELETE</v-btn>
      </div>
      <br>
      <br>
      <div v-if="!premiumUsr" class="freeUserMessage">
        <center>
        <h2>Incident alerts are disabled for free users</h2>
        <br>
          <v-btn id="premiumButton" :to="{path: 'goPremium'}" color="success">Go Premium!</v-btn>
        </center>
      </div>
    </v-layout>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { set } from 'vue/types/umd';
export default {
  data: () => ({
    watchlistSettings: [],
    watchlist: false,
    email: false,
    text: false,
    push: false,
    notificationsEnabled: false,
    textAlertingAllowed: false,
    premiumUsr: false,
    loading: false,
    watchlistID: null,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }

    if(!this.$route.query.id){
      this.$router.push({path: 'watchlist-settings'});
      return
    }
    if (localStorage.paid_user == "true"){
      this.premiumUsr = true;
      if (Notification.permission !== "granted"){
        confirm("Your browser currently has notitications disabled.\n\nAllow browser notitications to receive incident alerts.");
        Notification.requestPermission();
      }
    }

    if (localStorage.allow_text == "true"){
      this.textAlertingAllowed = true;
    }
    const watchlistID = this.$route.query.id
    this.watchlistID = watchlistID;
    this.getWatchlistSettings(watchlistID);
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async getWatchlistSettings(watchlistID){
      this.loading = true;
      const response = await fetch(localStorage.apiURL + "/app/watchlist/settings/"+ watchlistID, {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
      });

      if (!response.ok){
        this.loading = false;
        this.error("api returned " + response.status);
        return
      }

      let data = await response.json();

      if (!data.success){
        this.loading = false;
        this.error(data.msg);
        return
      }

      this.watchlistSettings = data.details;
      this.watchlist = data.details.watchlist;
      this.push = data.details.push;
      this.text = data.details.text;
      this.email = data.details.email;

      this.loading = false;
    },
    async saveButton(){
      let email = false;
      if (this.email){
        email = true;
      }
      const saveResponse = await fetch(localStorage.apiURL + "/app/watchlist/settings/" + this.watchlistID, {
        method: "PUT",
        headers: {"Content-Type": "application/json", "deviceID": localStorage.token, "tokenID": localStorage.tokenID},
        body: JSON.stringify({
          options: {
            push: this.push,
            watchlist: this.watchlist,
            email: email,
            text: this.text
          }
        })
      })

      if (!saveResponse.ok){
        this.loading = false;
        this.error("api returned " + saveResponse.status);
        return
      }

      const saveData = await saveResponse.json();

      if (!saveData.success){
        this.error("An error occured " + saveData.msg);
        return;
      }

      this.$router.push({path: 'watchlist-settings'});
    }, 
    goBack(){
      history.back();
    },
    async deleteButton(){
      const deleteResponse = await fetch(localStorage.apiURL + "/app/watchlist/settings/" + this.watchlistID, {
        method: "DELETE",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
      })

      if (!deleteResponse.ok){
        this.loading = false;
        this.error("api returned " + deleteResponse.status);
        return
      }

      const deleteData = await deleteResponse.json();

      if (!deleteData.success){
        this.error("An error occured " + deleteData.msg);
        return;
      }

      this.$router.push({path: 'watchlist-settings'});
    },
  },
};
</script>

<style scoped>
#departmentHeader {
  margin-bottom: 25px;
}

#saveButton {
  margin-right: 70px;
}
.switch{
  display: flex;
  justify-content: center;
}
  .watchlistSettings {
    margin-top: 25px;
    margin-top: 50px;
  }
  .freeUserMessage{
    margin-bottom: 50px;
  }
.button-container{
  margin-top: 30px;
}
#saveButton{
  width: 150px;
}

#deleteButton{
  width: 150px;
}
</style>
